import {use} from 'react';

import {VehicleSeriesDefinitionFormContext} from '../components/VehicleSeriesDefinitionFormContext';
import {VehicleSeriesDefinitionContextType} from '../utils/types';

export const useVehicleSeriesDefinitionContext = (): VehicleSeriesDefinitionContextType =>
  use(VehicleSeriesDefinitionFormContext);
